import React, { useEffect } from "react";
import Navbar from '../components/Navbar';
import { landingPageNavItems } from '../data/mockData';
import Quiz2 from '../components/Quiz2';
import { logEvent, logPageView } from "../utils/analytics";

const QuizPage = () => {
  useEffect(() => {
    // Track quiz page view
    logPageView('/quiz2');
    logEvent('Quiz', 'ViewContent', 'Quiz Step 2');
  }, []);

  const handleQuizInteraction = (questionId, answer) => {
    logEvent('Quiz', 'Answer', `Question ${questionId}`, answer);
  };

  return (
    <div className="min-h-screen bg-[#EDE3DD] p-2 md:p-8">
      <Navbar navItems={[]} />
      <Quiz2 onQuizInteraction={handleQuizInteraction} />
    </div>
  );
};

export default QuizPage;